import { HTTPMethod } from '@splunk/olly-services';
import { Endpoint } from '@splunk/olly-common/RBAC';

type EndpointsType = 'viewDashboardIndexPage' | 'viewDashboardPage' | 'viewChartPage';

export const dashboardsFeaturesEndpointMap: Record<EndpointsType, Endpoint[]> = {
    viewDashboardIndexPage: [
        // READ_BASIC_UI_ACCESS
        {
            path: '/v2/user/_/features',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/preferences',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/org-member',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/organizations',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/member/teams',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/org-preferences',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/subscription-info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/_/org-limits-list',
            httpMethod: HTTPMethod.GET,
        },
        // PERMIT_ALL
        {
            path: '/v2/user/_/info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/community/search',
            httpMethod: HTTPMethod.POST,
        },
        // READ_INTEGRATION
        {
            path: '/v2/integration',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/integration/_/aws-large-volume-integration',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DIMENSION
        {
            path: '/v1/dimension',
            httpMethod: HTTPMethod.GET,
        },
        // READ_METRIC
        {
            path: '/v1/metric',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DASHBOARD
        {
            path: '/v2/dashboard/_/searchCache',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DASHBOARD_GROUP
        {
            path: '/v2/dashboardgroup/_/dashboard-index',
            httpMethod: HTTPMethod.GET,
        },
        // READ_TEAM
        {
            path: '/v2/team/_/summary',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/team/_/members',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/team/_/fetch',
            httpMethod: HTTPMethod.GET,
        },
        // READ_SHAREABLE_SNAPSHOT
        {
            path: '/v2/shareablesnapshot/{id}',
            httpMethod: HTTPMethod.GET,
        },
        // MATCH_ANY - READ_ORGANIZATION, READ_BASIC_UI_ACCESS,  READ_GENERAL_SETTINGS
        {
            path: '/v2/organization/settings',
            httpMethod: HTTPMethod.GET,
        },
    ],
    viewDashboardPage: [
        // READ_BASIC_UI_ACCESS
        {
            path: '/v2/organization/member/teams',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/organizations',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/userchannel/spans',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/organization/subscription-info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/features',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/preferences',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/org-member',
            httpMethod: HTTPMethod.GET,
        },
        // READ_INTEGRATION
        {
            path: '/v2/integration/_/aws-large-volume-integration',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/integration',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DIMENSION
        {
            path: '/v1/dimension',
            httpMethod: HTTPMethod.GET,
        },
        // READ_METRIC
        {
            path: '/v1/metric',
            httpMethod: HTTPMethod.GET,
        },
        // PERMIT_ALL
        {
            path: '/v2/user/_/info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/community/search',
            httpMethod: HTTPMethod.POST,
        },
        // READ_DETECTOR
        {
            path: '/v2/detector/_/search',
            httpMethod: HTTPMethod.POST,
        },
        // READ_DASHBOARD
        {
            path: '/v2/dashboard/{id}/mirrorState',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/dashboard/_/hierarchy/{id}',
            httpMethod: HTTPMethod.GET,
        },
        // READ_SHAREABLE_SNAPSHOT
        {
            path: '/v2/shareablesnapshot/{id}',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DASHBOARD_GROUP
        {
            path: '/v2/dashboardgroup/{id}/dashboards',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/dashboardgroup',
            httpMethod: HTTPMethod.GET,
        },
        // READ_PERMISSION
        {
            path: '/v2/permissions/effective',
            httpMethod: HTTPMethod.GET,
        },
        // READ_ALERT
        {
            path: '/v2/alerts/_/bulksignalflow',
            httpMethod: HTTPMethod.POST,
        },
        // EXECUTE_SIGNAL_FLOW
        {
            path: '/v2/signalflow/_/getBatchedSignalFlowWithArgsInformation',
            httpMethod: HTTPMethod.POST,
        },
        // READ_TEAM
        {
            path: '/v2/team/_/fetch',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/team/_/summary',
            httpMethod: HTTPMethod.GET,
        },
        // READ_EVENT
        {
            path: '/v2/event/_termhistogram2',
            httpMethod: HTTPMethod.POST,
        },
        // MATCH_ANY - READ_DASHBOARD_DATA_LINK
        {
            path: '/v2/crosslink/_/all',
            httpMethod: HTTPMethod.GET,
        },
        // MATCH_ANY - READ_DASHBOARD_DATA_LINK, READ_GLOBAL_DATA_LINK
        {
            path: '/v2/crosslink/_/search',
            httpMethod: HTTPMethod.GET,
        },
        // MATCH_ANY - READ_ORGANIZATION, READ_BASIC_UI_ACCESS,  READ_GENERAL_SETTINGS
        {
            path: '/v2/organization/settings',
            httpMethod: HTTPMethod.GET,
        },
    ],
    viewChartPage: [
        // READ_BASIC_UI_ACCESS
        {
            path: '/v2/organization/subscription-info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/member/teams',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/preferences',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/org-preferences',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/org-member',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/userchannel/orgmetrics',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/userchannel/metrics',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/organization',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/_/features',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/organization/_/org-limits-list',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/user/organizations',
            httpMethod: HTTPMethod.GET,
        },
        // READ_TEAM
        {
            path: '/v2/team/_/summary',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/team/_/fetch',
            httpMethod: HTTPMethod.GET,
        },
        // READ_INTEGRATION
        {
            path: '/v2/integration/_/aws-large-volume-integration',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/integration',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DIMENSION
        {
            path: '/v1/dimension',
            httpMethod: HTTPMethod.GET,
        },
        // READ_METRIC
        {
            path: '/v1/metric',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DASHBOARD
        {
            path: '/v2/dashboard',
            httpMethod: HTTPMethod.GET,
        },
        // READ_DETECTOR
        {
            path: '/v2/detector/{id}',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/detector/_/search',
            httpMethod: HTTPMethod.POST,
        },
        // READ_SHAREABLE_SNAPSHOT
        {
            path: '/v2/shareablesnapshot/{id}',
            httpMethod: HTTPMethod.GET,
        },
        // PERMIT_ALL
        {
            path: '/v2/user/_/info',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/community/search',
            httpMethod: HTTPMethod.POST,
        },
        // READ_DASHBOARD_GROUP
        {
            path: '/v2/dashboardgroup',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/dashboardgroup/{id}',
            httpMethod: HTTPMethod.GET,
        },
        {
            path: '/v2/dashboardgroup/_/dashboardGroups',
            httpMethod: HTTPMethod.POST,
        },
        // READ_CHART
        {
            path: '/v2/chart/{id}',
            httpMethod: HTTPMethod.GET,
        },
        // READ_EVENT
        {
            path: '/v2/event/_termfetch2',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/event/find',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/event/_termhistogram2',
            httpMethod: HTTPMethod.POST,
        },
        // READ_ALERT
        {
            path: '/v2/alerts/_/bulksignalflow',
            httpMethod: HTTPMethod.POST,
        },
        // EXECUTE_SIGNAL_FLOW
        {
            path: '/v2/signalflow/_/getSignalFlowModel',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/signalflow/_/getMetricTypes',
            httpMethod: HTTPMethod.POST,
        },
        {
            path: '/v2/signalflow/_/getProgramInfo',
            httpMethod: HTTPMethod.POST,
        },
        // READ_PERMISSION
        {
            path: '/v2/permissions/effective',
            httpMethod: HTTPMethod.GET,
        },
        // MATCH_ANY - READ_DASHBOARD_DATA_LINK, READ_GLOBAL_DATA_LINK
        {
            path: '/v2/crosslink/_/all',
            httpMethod: HTTPMethod.GET,
        },
        // MATCH_ANY - READ_ORGANIZATION, READ_BASIC_UI_ACCESS,  READ_GENERAL_SETTINGS
        {
            path: '/v2/organization/settings',
            httpMethod: HTTPMethod.GET,
        },
    ],
};
